export default {
  drawer: null,
  color: 'secondary'
}
